import { render } from "./index_printed.vue?vue&type=template&id=31ddae38"
import script from "./index_printed.vue?vue&type=script&lang=js"
export * from "./index_printed.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__